import { useQuery } from "react-query";
import { Button } from "../../components/Button";
import { Input } from "../../components/Input";
import axios from "axios";
import { useRecoilValue } from "recoil";
import { authState } from "../../recoil";
import { useState } from "react";
import { Loader } from "../../components/Loader";
import { User } from "../../types/restaurant";
import { useNavigate } from "react-router-dom";

const RestaurantUsers = () => {
  const auth = useRecoilValue(authState);
  const [users, setUsers] = useState<User[]>([]);
  const [search, setSearch] = useState("");
  const navigate = useNavigate();

  const { data, isLoading, isFetching } = useQuery(
    ["Get Restaurant Users", auth?.restaurantId],
    async () => {
      const response = await axios.get("/order/cashier/restaurant", {
        params: {
          restaurantId: auth?.restaurantId,
        },
      });
      setUsers(response.data.users);
      return response.data.users;
    },
    {
      retry: 1,
      refetchOnWindowFocus: false,
    }
  );

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;

    const lowerValue = value.toLowerCase();
    setSearch(lowerValue);

    const normalizePhone = (phone: string) =>
      phone.replace(/^\+966/, "").replace(/\D/g, "");

    const normalizeSearch = (str: string) =>
      str
        .replace(/^\+966?/, "")
        .replace(/^\+96?/, "")
        .replace(/^\+9?/, "")
        .toLowerCase();

    const filtered = data?.filter((user: User) => {
      const fullName = `${user.firstName ?? ""} ${
        user.lastName ?? ""
      }`.toLowerCase();

      return (
        (user.phone &&
          normalizePhone(user.phone).includes(normalizeSearch(lowerValue))) ||
        (user.firstName && user.firstName.toLowerCase().includes(lowerValue)) ||
        (user.lastName && user.lastName.toLowerCase().includes(lowerValue)) ||
        fullName.includes(lowerValue)
      );
    });

    setUsers(filtered);
  };

  const handleClear = () => {
    setSearch("");
    setUsers(data);
  };

  return (
    <div className="mt-10">
      <p className="col-span-3 text-xl font-bold select-none">
        Search by Customer Name or Phone in Orders
      </p>

      <div className="w-full flex items-start gap-4 mt-4">
        <div>
          <Input
            className="w-40 md:w-96"
            placeholder="05XXXXXXXX or 9665XXXXXXXX"
            value={search}
            onChange={handleChange}
          />
        </div>

        <Button
          lightGreen
          onClick={handleClear}
          disabled={!search || isFetching || isLoading}
        >
          Clear
        </Button>
      </div>

      <div className="mt-6">
        {isLoading || isFetching ? (
          <div className="w-40 md:w-96 flex justify-center items-center pt-10">
            <Loader />
          </div>
        ) : users?.length === 0 ? (
          <p className="text-gray-500">No users found.</p>
        ) : (
          <>
            <p className="mb-2 font-bold">Restaurant Users</p>
            <ul className="space-y-2">
              {users?.map((user: any) => (
                <li
                  key={user.id}
                  className="w-full max-w-[50rem] cursor-pointer hover:bg-green-100 p-4 border bg-green-50 rounded-md shadow-sm flex flex-wrap md:flex-row justify-between items-end gap-2"
                  onClick={() => navigate(`user/${user?.id}`)}
                >
                  <div className="w-2/3 grid grid-cols-1 gap-2">
                    <p className="font-semibold flex items-center gap-1">
                      <span className="text-sm font-medium text-PrimaryGray">
                        Customer:
                      </span>{" "}
                      {user?.firstName} {user?.lastName}
                    </p>
                    <p className="text-base font-semibold flex items-center gap-1">
                      <span className="text-sm font-semibold text-PrimaryGray">
                        Phone:
                      </span>{" "}
                      +966
                      {user?.phone}
                    </p>
                    <p className="text-base font-semibold flex items-center gap-1">
                      <span className="text-sm font-medium text-PrimaryGray">
                        Total Orders:{" "}
                      </span>
                      {user?.totalOrders}
                    </p>
                    <p className="text-base font-semibold flex items-center gap-1">
                      <span className="text-sm font-medium text-PrimaryGray">
                        Total Visits Number:{" "}
                      </span>
                      {user?.totalOrders}
                    </p>
                  </div>

                  <div className="font-medium text-base text-right flex flex-nowrap text-nowrap items-center gap-1">
                    Total Price:{" "}
                    <span className="text-primary text-lg font-semibold">
                      {user?.totalPrice?.toFixed(2)}
                    </span>{" "}
                    SAR
                  </div>
                </li>
              ))}
            </ul>
          </>
        )}
      </div>
    </div>
  );
};

export default RestaurantUsers;
